import { $$ } from '@zimpa/dom';

const SELECTOR =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function findElements(container: HTMLElement): HTMLElement[] {
    return $$<HTMLElement>(SELECTOR, container).filter(
        (el: HTMLElement): boolean => {
            const isNotDisabled = !el.hasAttribute('disabled');
            const isVisible: boolean = el.offsetParent !== null;
            const isTabbable: boolean =
                !el.hasAttribute('tabindex') ||
                parseInt(el.getAttribute('tabindex') as string, 10) >= 0;

            return isNotDisabled && isVisible && isTabbable;
        },
    );
}
